var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"splash"},[(_vm.show_lottie)?_c('lottie-animation',{staticClass:"lottie-img-delete",attrs:{"speed":1,"autoPlay":true,"path":"../lottie/splash.json"}}):_vm._e(),_c('transition',{attrs:{"name":"bounce"}},[(!_vm.show_lottie)?_c('img',{staticClass:"logo",attrs:{"src":"/images/logo.png","alt":"Logo"}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }